<!-- Confirmation Modal for AI Generating Responses -->
<script lang="ts">
    import { getModalStore, type ModalStore } from "@skeletonlabs/skeleton";

    import BlackX from "$lib/assets/BlackX.svg";

    const modalStore: ModalStore = getModalStore();

    function do_submit(e: Event) {
        e.preventDefault();
        $modalStore[0].response!({ confirm: true });
        modalStore.clear();
    }
</script>

<div class="bg-white rounded-lg p-8">
    <div class="flex items-center">
        <p class="font-bold">Confirm Deletion</p>
        <button
            class="ml-auto rounded-full hover:bg-stone-100 transition duration-300 p-1"
            on:click={() => modalStore.clear()}
        >
            <img src={BlackX} alt="Exit" />
        </button>
    </div>

    <form on:submit={do_submit}>
        <p class="w-80 mt-8 text-sm">
            Are you sure you want to delete the chosen Q&A pair(s)? All selected information will be permanently
            deleted.
        </p>
        <div class="flex mt-10">
            <button
                type="submit"
                class="rounded-full bg-zinc-800 px-4 py-2 text-white hover:shadow-md transition duration-300 text-sm"
            >
                Delete
            </button>
            <button
                type="button"
                class="rounded-full border border-black text-sm ml-3 px-4 py-2 hover:shadow-md transition duration-300"
                on:click={() => modalStore.clear()}
            >
                Cancel
            </button>
        </div>
    </form>
</div>
